import React, { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import './Profile.css';

export default function DeletionStatus() {
  const { deletion, token, sessionError, retrySession, refreshDeletion, submitDeletion, logout } = useAuth();
  const heading = useRef(null);
  const completed = deletion.operation?.phase === 'completed';
  useEffect(() => { heading.current?.focus(); }, [completed]);
  const pending = Boolean(deletion.operation) || deletion.accepted;
  const busy = deletion.kind === 'submitting' || deletion.kind === 'checking';
  function retryDeletion() {
    // This control disappears when submission starts; keep keyboard focus on
    // the persistent recovery heading through verification and its response.
    heading.current?.focus();
    submitDeletion();
  }
  return <section className="profile-container deletion-status" aria-labelledby="deletion-heading">
    <p className="eyebrow">YOUR BASE CAMP</p>
    <h1 id="deletion-heading" tabIndex={-1} ref={heading}>{completed ? 'Account cleanup complete' : pending ? 'Account deletion in progress' : busy ? 'Checking your deletion request' : 'Deletion status needs checking'}</h1>
    <div className="profile-card">
      <p role="status">{completed
        ? 'Your sign-in account was removed and NameCamper account-record cleanup completed. A minimal deletion record is retained to prevent the account from being recreated.'
        : pending
          ? 'Your deletion request is saved. New checks and notification sends for this account are suppressed. The server continues deleting your sign-in account and cleaning up account records, even if you close this page or lose your session.'
          : 'We have not confirmed whether a deletion request is saved. Account actions are paused here while you check. A lost connection or session does not confirm completion.'}</p>
      {pending && !completed && <p className="setting-description">A message already being sent may still arrive. Completion has not been confirmed. Delays can require service review; refreshing does not restart or cancel the job.</p>}
      {completed && <p className="setting-description">This does not mean every backup, shared cache or historical record has been erased.</p>}
      {deletion.error && <p className="alert alert-error" role="alert">{deletion.error}</p>}
      {sessionError && <p className="alert alert-error" role="alert">{sessionError}</p>}
      {!token && <p>Your session is unavailable. A saved deletion request continues on the server. Sign in again only to check owned status; inability to sign in is not proof of completion.</p>}
      <div className="deletion-status-actions">
        {token && !completed && <button className="btn btn-primary" disabled={busy} onClick={refreshDeletion}>{busy ? 'Checking…' : 'Check deletion status'}</button>}
        {token && deletion.canRetry && !busy && <button className="btn btn-danger" onClick={retryDeletion}>Retry deletion request</button>}
        {!token && <button className="btn btn-secondary" onClick={retrySession}>Retry session</button>}
        <button className="btn btn-secondary" onClick={() => logout()}>Sign out</button>
      </div>
      <p className="setting-description">Signing out does not cancel a saved request.</p>
    </div>
  </section>;
}
